import { render, staticRenderFns } from "./DiagramBuilder.vue?vue&type=template&id=6773b34e&scoped=true"
import script from "./DiagramBuilder.vue?vue&type=script&lang=js"
export * from "./DiagramBuilder.vue?vue&type=script&lang=js"
import style0 from "./DiagramBuilder.vue?vue&type=style&index=0&id=6773b34e&prod&lang=scss&scoped=true"
import style1 from "./DiagramBuilder.vue?vue&type=style&index=1&id=6773b34e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6773b34e",
  null
  
)

export default component.exports